export const MESSAGE = {
  loginSuccess: "LoggedIn Successfully!",
  signupSuccess: "Signup Successfully!",
  emptyStringValidation:
    "You have not filled out all fields. Please check your entries and try again",
};
